import React from "react";
import {
  FaCircle,
  FaSquare,
  FaPlay,
  FaStar,
  FaEllipsisH,
  FaDiceSix,
  FaDatabase,
  FaCloud,
  FaGem,
} from "react-icons/fa";
import { ShapeKind } from "../types/shapes";

interface ShapeSelectorProps {
  shape: ShapeKind;
  setShape: (shape: ShapeKind) => void;
}

const ShapeSelector: React.FC<ShapeSelectorProps> = ({ shape, setShape }) => {
  return (
    <div className="shape-selector">
      <h4>Shape</h4>
      <div className="btn-group shape-btn-group" role="group">
        <button
          type="button"
          className={`btn shape-btn ${shape === "circle" ? "active" : ""}`}
          onClick={() => setShape("circle")}
          aria-label="Circle"
        >
          {React.createElement(FaCircle as any, { size: 14 })}
        </button>

        <button
          type="button"
          className={`btn shape-btn ${shape === "square" ? "active" : ""}`}
          onClick={() => setShape("square")}
          aria-label="Square"
        >
          {React.createElement(FaSquare as any, { size: 14 })}
        </button>

        <button
          type="button"
          className={`btn shape-btn ${shape === "triangle" ? "active" : ""}`}
          onClick={() => setShape("triangle")}
          aria-label="Triangle"
        >
          {React.createElement(FaPlay as any, {
            size: 14,
            style: { transform: "rotate(90deg)" },
          })}
        </button>

        <button
          type="button"
          className={`btn shape-btn ${shape === "star" ? "active" : ""}`}
          onClick={() => setShape("star")}
          aria-label="Star"
        >
          {React.createElement(FaStar as any, { size: 14 })}
        </button>

        <button
          type="button"
          className={`btn shape-btn ${shape === "oval" ? "active" : ""}`}
          onClick={() => setShape("oval")}
          aria-label="Oval"
        >
          {React.createElement(FaEllipsisH as any, { size: 14 })}
        </button>

        <button
          type="button"
          className={`btn shape-btn ${shape === "hexagon" ? "active" : ""}`}
          onClick={() => setShape("hexagon")}
          aria-label="Hexagon"
        >
          {React.createElement(FaDiceSix as any, { size: 14 })}
        </button>

        <button
          type="button"
          className={`btn shape-btn ${shape === "diamond" ? "active" : ""}`}
          onClick={() => setShape("diamond")}
          aria-label="Diamond"
        >
          {React.createElement(FaGem as any, { size: 14 })}
        </button>

        <button
          type="button"
          className={`btn shape-btn ${shape === "database" ? "active" : ""}`}
          onClick={() => setShape("database")}
          aria-label="Database"
        >
          {React.createElement(FaDatabase as any, { size: 14 })}
        </button>

        <button
          type="button"
          className={`btn shape-btn ${shape === "cloud" ? "active" : ""}`}
          onClick={() => setShape("cloud")}
          aria-label="Cloud"
        >
          {React.createElement(FaCloud as any, { size: 14 })}
        </button>
      </div>
    </div>
  );
};

export default ShapeSelector;
